import { createFileRoute } from "@tanstack/react-router";
import ServiceMetaAds from "@/pages/ServiceMetaAds";
import {
  buildPageHead,
  breadcrumbSchema,
  serviceSchema,
  faqPageSchema,
} from "@/lib/seo";

const faqs = [
  {
    question: "What does a Meta Ads performance specialist do?",
    answer:
      "A Meta Ads performance specialist designs and scales the complete ad infrastructure: Meta Conversions API tracking, audience seed libraries, creative-testing frameworks, profitable scaling logic, and profitability dashboards. They engineer the system, not just buy media.",
  },
  {
    question: "Can you fix attribution broken since iOS 14?",
    answer:
      "Yes. I implement Meta Conversions API with event deduplication and first-party data routing so attribution reconciles with your actual revenue, replacing unreliable pixel-only reporting with server-side truth.",
  },
  {
    question: "How do you scale Meta ads without breaking profitability?",
    answer:
      "Every account I architect uses MER-based guardrails and budget-pacing automation. Scaling triggers only fire when marketing efficiency ratio holds, so CPA stays protected as spend grows from 5x to 50x.",
  },
  {
    question: "How much does a Meta Ads specialist cost?",
    answer:
      "Engagements are scoped per project or retainer. A senior ads specialist delivers the full tracking and scaling architecture at a fraction of a US agency rate. Book a free ads audit call to receive a custom scope and quote.",
  },
];

export const Route = createFileRoute("/meta-ads-performance-specialist")({
  head: () =>
    buildPageHead({
      title:
        "Meta Ads Performance Specialist & CAPI Conversion Tracking Expert",
      description:
        "Hire a dedicated Meta Ads Performance Specialist. Conversions API tracking, creative-testing frameworks, audience seed libraries, and profitable scaling logic for brands that refuse to waste ad spend.",
      path: "/meta-ads-performance-specialist",
      keywords:
        "Meta Ads specialist, Meta Ads expert, Meta Conversions API, Facebook ads expert Philippines, paid ads performance specialist, ad scaling, creative testing framework, MER ROAS, hire Meta Ads specialist",
      schema: [
        serviceSchema({
          name: "Meta Ads Performance Architecture & Conversion Tracking",
          description:
            "Meta Conversions API tracking, creative-testing frameworks, audience seed libraries, and profitable scaling logic for scaling brands.",
          path: "/meta-ads-performance-specialist",
          serviceType: [
            "Meta Ads Architecture",
            "Conversions API Implementation",
            "Creative-Testing Frameworks",
            "Profitable Scaling Logic",
          ],
        }),
        breadcrumbSchema([
          { name: "Home", path: "" },
          {
            name: "Meta Ads Performance Specialist",
            path: "/meta-ads-performance-specialist",
          },
        ]),
        faqPageSchema(faqs),
      ],
    }),
  component: ServiceMetaAds,
});
